package ai.jessie.web.pages.profile

import ai.jessie.web.profile.emailChangeOutcome
import ai.jessie.web.profile.emailChangeResult
import ai.jessie.web.theme.entryFrame
import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext

// UC-026 A3/A4 callback destination. It sends no request: the outcome is presentation only and
// grants nothing; after `changed` the server has already revoked every session.
@Page("email-result")
@Composable
fun emailResultPage(ctx: PageContext) {
    val result = emailChangeResult(ctx.route.params["outcome"])
    entryFrame("E-Mail-Änderung", authenticationRequired = result.signInRequired) {
        emailChangeOutcome(result)
    }
}
